var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigFw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-table/5/row-select--",
    transform: "translate(-1284.000000, -19.000000)",
    stroke: "#727E8C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-table/5/row--"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/chevron-right/black"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.903382, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/chevron-down/black",
    transform: "translate(12.599034, 12.000000) rotate(-90.000000) translate(-12.599034, -12.000000) "
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "6.29951691 10 12.5990338 16 18.8985507 10"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFw);
export default __webpack_public_path__ + "static/media/big-fw.0f828a97.svg";
export { ForwardRef as ReactComponent };